<div *ngFor="let port of CruisePCIInfo; let i=index;">
    <div class="portcity">{{port.poc}}</div>
    <div class="row" *ngIf="i!=0">
        <div class="arrival col-3"><span class="arrdpt"> Arrive: </span></div>
        <div class="datecol col-9"> {{port.itiBegDate|
            date:'EEE, MMMM d, y h:mm a'}}</div>
    </div>
    <div class="row" *ngIf="i!=CruisePCIInfo.length-1">
        <div class="departure col-3"><span class="arrdpt">Depart: </span> </div>
        <div class="datecol col-9">{{port.itiEndDate|
            date:'EEE, MMMM d, y h:mm a'}}</div>
    </div>
    <div class="row" *ngIf="i==CruisePCIInfo.length-1">
        <div class="departure col-3"><span class="arrdpt">Disembark: </span> </div>
        <div class="datecol col-9">{{port.itiEndDate|
            date:'EEE, MMMM d, y '}} 8:00 AM</div>
    </div>
    <div class="PortInfoLink">
        <button class="btn btn-light nav-item nav-link-edit" [routerLink]="['/portinfo/']"
            [queryParams]="{inputdate:port.itiBegDate, 'portcity': port.poc}">View Port
            Information</button>
    </div>
    <div class="tenpxtop"></div>
</div>